/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Converter_Time_ShortInputs */

const en_ui_labs_converter_time_short = /** @type {(inputs: Ui_Labs_Converter_Time_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const de_ui_labs_converter_time_short = /** @type {(inputs: Ui_Labs_Converter_Time_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Ui_Labs_Converter_Time_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_converter_time_short = /** @type {((inputs?: Ui_Labs_Converter_Time_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Converter_Time_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_converter_time_short(inputs)
	return de_ui_labs_converter_time_short(inputs)
});